import { render, staticRenderFns } from "./VSTable.vue?vue&type=template&id=73b781fc"
import script from "./VSTable.vue?vue&type=script&lang=js"
export * from "./VSTable.vue?vue&type=script&lang=js"
import style0 from "./VSTable.vue?vue&type=style&index=0&id=73b781fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports